import React, {
  FC, ReactNode,
} from 'react';
import '../../styles/components/modal.scss';
import { zIndexCurrentTimeLine } from '@utils';
import { Loader } from '../loader';
import { Portal } from '../portal';

interface ModalProp {
  width: string | number;
  maxWidth?: string | number;
  minWidth?: string | number;
  height?: number;
  children?: ReactNode;
  isShow: boolean;
  loading?: boolean;
  renderButtons?: () => ReactNode;
  closeModal: () => void;
}

export const Modal: FC<ModalProp> = ({
  width, maxWidth, minWidth, height, children, isShow, loading, renderButtons, closeModal,
}) => {

  return isShow && (
    <Portal where={document.getElementById('modalContainer')}>
      <div
        className="wrapper"
        onClick={closeModal}
        style={{ zIndex: zIndexCurrentTimeLine + 1 }}
      >
        <div
          className="modal"
          onClick={(e) => e.stopPropagation()}
          style={{
            width, maxWidth, minWidth, height,
          }}
        >
          {!loading ? (
            <div className="content">
              {children}
            </div>
          ) : (
            <Loader />
          )}
          {renderButtons && !loading
            && (
              <div className="buttons">
                {renderButtons()}
              </div>
            )}
        </div>
      </div>
    </Portal>
  );
};
